import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth';

export const coordinatorGuard: CanActivateFn = () => {
  const auth   = inject(Auth);
  const router = inject(Router);

  if (!auth.isLoggedIn() || auth.getRole() !== 'COORDINATOR') {
    router.navigate(['/auth/coordinator-login']);
    return false;
  }

  return true;
};
